<template>
    <div>
        <page-header :heading="pageHeader.title"
                     :buttons="pageHeader.buttons" />

        <hr />

        <div>
            <div class="form-inline">
                <label class="sr-only" for="newLabel">Label</label>
                <input type="text" v-model="addComponentObj.label" class="form-control form-control-sm mb-2 mr-sm-2" id="newLabel" placeholder="Label">
                <label class="sr-only" for="newComp">Name</label>
                <input type="text" v-model="addComponentObj.component" class="form-control form-control-sm mb-2 mr-sm-2" id="newComp" placeholder="Component">
                <div class="custom-control custom-checkbox  mb-2 mr-sm-4">
                    <input type="checkbox" class="custom-control-input" id="newEnabled" v-model="addComponentObj.enabled">
                    <label class="custom-control-label" for="newEnabled">Enabled</label>
                </div>
                <button class="btn btn-sm btn-primary mb-2" @click="handleAddCompClick">Add Component</button>
            </div>
        </div>


        <data-list :dataCols="ruleComponentCols"
                   :dataListItems="ruleComponentList"
                   :tableClass="'table table-striped table-sm'" />

        <hr />

        <loading :active.sync="isLoading"
                 :can-cancel="false"
                 :is-full-page="true"></loading>
    </div>
</template>

<script>

//import OrderBy from '@/components/OrderBy.vue'
import PageHeader from '@/components/PageHeader.vue'
import DataList from '@/components/DataList.vue'
//import DataListCSV from '@/components/DataListCSV.vue'


//import PageSize from '@/components/PageSize.vue'
//import SearchForm from '@/components/SearchForm.vue'
//import { searchInputs } from '@/ui.config/inputs/claimsBucket1SearchInputs'
import { ruleComponentCols } from '@/ui.config/cols/pipelineCols'

import { mapActions } from 'vuex'

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

const addComponentEmpty = {
    label: null,
    component: null,
    enabled: true
    }

export default {
    name:'RuleComponents',
    mixins: [

    ],
    components: {
        PageHeader,
        DataList,
        Loading
    },
    data: () => {
        return {
            pageHeader: {
                title: 'Rule Components',
            },
           
            ruleComponentCols: ruleComponentCols,

            addComponentObj: addComponentEmpty,
        }
    },
    beforeMount() {
        this.fetchPipelines({})
        this.$store.commit('setPipelineRules', null)
        this.fetchPipelineTypes()
        this.fetchRuleComponents()
        this.fetchResellers()
        this.fetchIncidentTypes()

    },
        computed: {
        isLoading() {
            return this.$store.getters.isLoading
        },
        searchInputsEx() {
            var { resellers, incidentTypes,  searchInputs } = this

            if (resellers) {
                searchInputs[0].options = resellers
            }

            if (incidentTypes) {
                searchInputs[5].options = incidentTypes
            }

            return searchInputs
        },
        pipelineList() {
            return this.$store.getters.pipelineList
        },
        selectedPipeline() {
            return this.$store.getters.selectedPipeline
        },
        pipelineTypeList() {
            return this.$store.getters.pipelineTypeList
        },
        pipelineRuleList() {
            return this.$store.getters.pipelineRuleList
        },
        ruleComponentList() {
            return this.$store.getters.ruleComponents
        }
    },
    methods: {
        ...mapActions([
            'fetchPipelines',
            'fetchPipelineTypes',
            'fetchPipelineRules',
            'fetchResellers',
            'fetchIncidentTypes',
            'setSelectedPipeline',
            'fetchRuleComponents',
            'addPipelineRule',
            'addPipeline',
            'addRuleComponent'
        ]),
        //handleItemDblClick(payload) {
        //    this.setSelectedPipeline(payload)
        //    let { id: pipelineId } = payload
        //    this.fetchPipelineRules({ pipelineId : pipelineId})
        //},
        //handleAddRuleClick() {
        //    let { id: ruleId } = this.newRule
        //    let { id: pipelineId } = this.selectedPipeline
        //    this.addPipelineRule({ ruleId, pipelineId })
        //},
        //handleAddPipelineClick() {
        //    let { newLabel: label, newType: pipelineType, newEabled: enabled } = this
        //    this.addPipeline({ label, pipelineTypeId: pipelineType.id, enabled })
        //},
        handleAddCompClick() {
            let { label, component } = this.addComponentObj
            if (label && component) {
                this.addRuleComponent(this.addComponentObj)
                this.addComponentObj = addComponentEmpty
            }
        }
    }
}
</script>

<style>
</style>
